Monitoring.Views ||= {}

class AccountSettings.MarketingAccountSelectorView extends Backbone.View
  template: JST["backbone/templates/account_settings/topics/marketing_account_selector"]

  events:
    'click .add_marketing_account_btn': 'onClickAdd'
    'click .close_selector_btn': 'onClickClose'
  tagName: 'div'
  className: 'marketing_account_selection_view_wrapper'

  initialize: (@options = {}) ->
    @marketingAccounts = @options.marketingAccounts

  render: =>
    @$el.html(@template({marketing_accounts: @marketingAccounts}))
    @

  onClickClose:(event)->
    event.stopPropagation()
    @trigger('marketing-account:selector:click:close')

  onClickAdd:(event)=>
    event.stopPropagation()
    selectedMarketingAccount = @$el.find('#marketing-account-options option:selected')[0]
    marketingAccountId = selectedMarketingAccount.value
    marketingAccount = {accountId: marketingAccountId, accountName: $(selectedMarketingAccount).attr("data-marketing-account-name") }
    @trigger('marketing-account:click:add', marketingAccount)
    @trigger('marketing-account:selector:click:close')
